import { connect } from "react-redux";
import NotificationTypes from "notifications/components/types";

/* connect notification types where needed */

export default NotificationTypes;
